<template>
    <div class="container">
    <div class="card">
        <h2>Success!</h2>
        <p>You have successfully subscribed to our service, Thank you! </p>
        <p>You are awesome!</p> 
        <p> Enjoy it, and have a great day!</p>  
        <div class="button-container">
              <button class="home-btn" @click="goToHomepage"><strong> START </strong></button>
        </div>
    </div>
    </div>
</template>

<script lang="ts" setup>

import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';

const router = useRouter()

const goToHomepage= () => {
  const userStore = useUserStore();
  userStore.fetchUser(true)
  router.push('/home')

};

</script>

<style scoped>

.container {
  width: 100%;
  max-width: 400px;
  margin: 150px auto;
  padding-top: 20px;
  background-color: white;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  gap: 10px;
  padding: 10px;
}

.card {
  background-color: white;
  justify-content: center;
  border-radius: 12px;
  width: 88%;
  color: #64748b;
  border: 2px solid #ccc;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: 150px auto;
  padding: 20px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: center;
}

h2 {
    text-align: center;
}

p {
  text-align: center;
}

hr.sub-hr {
    margin-top: 1rem;
    width: 100%;
    border: 1px solid gray;
}

button.home-btn {
  padding: 10px 15px;
  display: flex;
  background-color: #0fe556;
  color: #64748b;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

button.home-btn:hover {
  background-color: #578FCA;
}

</style>